module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-on-the-beach.9dfe06f7.png";